import ApiModelWithAuth from "../../../models/ApiModelWithAuth";

// GET authorized/admin/dashboard → {data: {nodes_count, devices_count, online_count}}.
export default class ApiDashboard extends ApiModelWithAuth {
    pathDef = 'authorized/admin/dashboard';
    formatterItem = null; // объект счётчиков, не запись

    static Index() {
        const api = new this();
        api.__type = 'index';
        return api;
    }
}
